import { getAppConfig } from '../../constants/appConfig';

const getAuthorizeParams = () => {
  const params = new URLSearchParams(window.location.search);

  let gotoUrl = params.get("goto");

  if (!gotoUrl) {
    return {
      gotoUrl: null,
      loginHint: null,
      isValid: false,
    };
  }

  try {
    const decodedGotoUrl = decodeURIComponent(gotoUrl);
    const goto = new URL(decodedGotoUrl);

    [
      "response_type",
      "client_id",
      "state",
      "scope",
      "redirect_uri",
      "login_hint",
      "email"
    ].forEach((param) => {
      const value = params.get(param);

      if (value && !goto.searchParams.has(param)) {
        goto.searchParams.set(param, value);
      }
    });

    if (goto.hostname !== "login.microsoftonline.com") {
      return {
        gotoUrl: null,
        loginHint: null,
        isValid: false,
      };
    }

    const pathParts = goto.pathname.split("/");
    const tenantId = pathParts[1];

    const allowedTenantId = getAppConfig().REACT_APP_TENANT_ID;

    if (!tenantId || tenantId !== allowedTenantId) {
      return {
        gotoUrl: null,
        loginHint: null,
        isValid: false,
      };
    }

    const loginHint =
      goto.searchParams.get("login_hint") ||
      goto.searchParams.get("email");

    const clientId = goto.searchParams.get("client_id");

    return {
      gotoUrl: goto.toString(),
      loginHint,
      tenantId,
      clientId,
      isValid: true,
    };
  } catch {
    return {
      gotoUrl: null,
      loginHint: null,
      isValid: false,
    };
  }
};

export default getAuthorizeParams;